import styled from 'styled-components';
import { COLOR } from '../../../../packages/constants';

interface AccountsPanelProps {
    width: number;
}

export const AccountsPanel = styled.div<AccountsPanelProps>`
    min-width: ${(props) => `${props.width}px`};
    display: flex;
    flex-direction: column;
    position: relative;

    &::after {
        border-left: 1px solid ${COLOR.MAIN.FORM_FIELD};
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 1px;
        height: 17px;
    }
`;
